{
  "version": 1,
  "asset_id": "a4d6e8b9-6c51-49ea-a6a8-f5541f47d9d5",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a4d6e8b9-6c51-49ea-a6a8-f5541f47d9d5/ai-search-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a4d6e8b9-6c51-49ea-a6a8-f5541f47d9d5/ai-search-1280.webp",
  "original_filename": "ai-search-1280.webp",
  "size": 52192,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:45Z"
}
